export default "__VITE_ASSET__DM5$$qaj__"